/******/ (() => { // webpackBootstrap
/* eslint-disable */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.cacheDOMElements();
    /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
    this.onSubmitBound = this.onSubmit.bind(this);
    /* ===== Remove the noscript elements from the DOM (javascript is enabled) ===== */
    Array.from(this.noscriptElements).forEach(element => element.remove());
  }

  cacheDOMElements() {
    /* ===== Cache the DOM elements ===== */
    this.form = this.querySelector('form');
    this.noscriptElements = this.querySelectorAll('noscript');
    this.sectionId = this.getAttribute('data-section-id');
    this.productInformation = this.closest('product-information');
    this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
    this.cartType = document.getElementById('PageContainer').dataset.cartType;
    this.cartCountIndicator = document.querySelector('[data-cart-count-indicator]');
    this.giftWrapProductId = this.getAttribute('data-gift-wrap-product-id');
    this.wethemeGlobal = document.querySelector('script#wetheme-global');
    this.translationsObject = JSON.parse(this.wethemeGlobal.textContent);
    this.qtyErrorMessage = this.querySelector('[data-qty-error-message]');
  }

  connectedCallback() {
    /* ===== Set the initial state of the add to cart button ===== */
    if (!this.form) return;
    this.attachEventListeners();
  }

  attachEventListeners() {
    /* ===== Attach the event listeners to the DOM elements ===== */
    this.form.addEventListener('submit', this.onSubmitBound);
  }

  onSubmit(event) {
    /* ===== Handle the form submission ===== */
    event.preventDefault();
    this.prepareForSubmission();
  }

  prepareForSubmission() {
    /* ===== Prepare the form for submission ===== */
    this.cacheSubmissionElements();
    if (!this.checkRequiredInputs()) return;
    this.disableBlankInputs();
    // If the form is valid, proceed with the submission
    this.showLoadingState();
    this.addItemsToCart();
  }

  cacheSubmissionElements() {
    /* ===== Cache the elements needed for form submission ===== */
    this.loadingIcon = this.form.querySelector('[data-loading-icon]');
    this.addToCartText = this.form.querySelector('[data-add-to-cart-text]');
    this.addedText = this.form.querySelector('[data-cart-added-text]');
    this.quantityInput = this.form.querySelector('[name="quantity"]');
    this.quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;
  }

  disableBlankInputs() {
    // Select all input and textarea elements
    const elements = this.productInformation.querySelectorAll('input, textarea');
    this.blankElements = [];

    elements.forEach((element) => {
      // Check if the element has no value
      if (!element.value) {
        // Temporarily disable the element so that it is not included in the form submission
        element.disabled = true;
        this.blankElements.push(element);
      }
    });
  }

  enableBlankInputs() {
    // Enable the blank elements that were disabled
    this.blankElements.forEach((element) => {
      element.disabled = false;
    });
    this.blankElements = [];
  }

  fetchConfig(type = 'json') {
    /* ===== Create the fetch configuration object ===== */
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  checkRequiredInputs() {
    /* ===== Check if the required inputs have been filled out ===== */
    const requiredInputs = Array.from(this.productInformation.querySelectorAll('[required]:not(:disabled)'));
    this.clearErrorMessages();
  
    const invalidInputs = requiredInputs.filter(input => {
      if (input.type === 'checkbox') {
        return !input.checked;
      } else {
        return !input.value.trim();
      }
    });
  
    invalidInputs.forEach(input => this.applyErrorMessage(input));
    return invalidInputs.length === 0;
  }  

  clearErrorMessages() {
    /* ===== Clear the error messages from the form ===== */
    this.productInformation.querySelectorAll('.required-field-error').forEach(error => error.remove());
  }

  applyErrorMessage(input) {
    /* ===== Apply the error message to the input element if the required input is empty ===== */
    if (!input) return;
  
    const errorMessage = input.hasAttribute('custom-dropdown-input') ? this.translationsObject.translations.required_dropdown_error 
                      : input.type === 'file' ? this.translationsObject.translations.required_upload_error 
                      : input.type === 'checkbox' ? this.translationsObject.translations.required_checkbox_error 
                      : this.translationsObject.translations.required_input_error;
  
    const errorElement = `<span class="required-field-error errors" style="display: block; color: red;">${errorMessage}</span>`;
  
    if (input.id === 'upload_image') {
      const fileErrorContainer = input.closest('#upload_image-container');
      
      if (!fileErrorContainer.querySelector('.required-field-error')) {
        fileErrorContainer.insertAdjacentHTML('beforebegin', errorElement);
      }
    } else if (input.id === 'sleeve_text') {
      const fileErrorContainer = input.closest('#sleeve_text-container');
      

      if (!fileErrorContainer.querySelector('.required-field-error')) {
        fileErrorContainer.insertAdjacentHTML('beforebegin', errorElement);
      }
    } else if (input.id === 'second_upload_image') {
      const fileErrorContainer = input.closest('#second_upload_image-container');
      
      if (!fileErrorContainer.querySelector('.required-field-error')) {
        fileErrorContainer.insertAdjacentHTML('beforebegin', errorElement);
      }
    } else if (input.id === 'mug_text') {
      const fileErrorContainer = input.closest('#mug_text-container');
      
      if (!fileErrorContainer.querySelector('.required-field-error')) {
        fileErrorContainer.insertAdjacentHTML('beforebegin', errorElement);
      }
    } else if (input.id === 'second_drawing_note') {
      const fileErrorContainer = input.closest('#second_drawing_note-container');
      

      if (!fileErrorContainer.querySelector('.required-field-error')) {
        fileErrorContainer.insertAdjacentHTML('beforebegin', errorElement);
      }
    } else {
      const errorContainer = input.closest('.input-wrapper')?.querySelector('.input-error-container');
      
      if (errorContainer) {
        errorContainer.innerHTML = errorElement;
      } else if (!input.previousElementSibling?.classList.contains('required-field-error')) {
        input.insertAdjacentHTML('beforebegin', errorElement);
      }
    }
  
    input.focus();

    if (input.id === 'upload_image') {
      const fileErrorContainer = input.closest('#upload_image-container');
      const fileError = fileErrorContainer.previousElementSibling;
      
      input.addEventListener('change', () => {
        fileError?.remove();
      }, { once: true });
    } else if (input.id === 'sleeve_text') {
      const fileErrorContainer = input.closest('#sleeve_text-container');
      const fileError = fileErrorContainer.previousElementSibling;
      
      input.addEventListener('change', () => {
        fileError?.remove();
      }, { once: true });
    } else if (input.id === 'second_upload_image') {
      const fileErrorContainer = input.closest('#second_upload_image-container');
      const fileError = fileErrorContainer.previousElementSibling;
      
      input.addEventListener('change', () => {
        fileError?.remove();
      }, { once: true });
    } else if (input.id === 'mug_text') {
      const fileErrorContainer = input.closest('#mug_text-container');
      const fileError = fileErrorContainer.previousElementSibling;
      
      input.addEventListener('change', () => {
        fileError?.remove();
      }, { once: true });
    } else if (input.id === 'second_drawing_note') {
      const fileErrorContainer = input.closest('#second_drawing_note-container');
      const fileError = fileErrorContainer.previousElementSibling;
      
      input.addEventListener('change', () => {
        fileError?.remove();
      }, { once: true });
    } else {
      input.addEventListener('input', () => {
        const genericError = this.productInformation.querySelector('.required-field-error');
        genericError?.remove();
      }, { once: true });
    }
  }

  giftWrapEnabled() {
    /* ===== Determine if the gift wrap product is enabled ===== */
    return !!this.productInformation.querySelector('[name="properties[Gift wrap]"]')?.checked && this.giftWrapProductId !== '';
  }

  async addItemsToCart() {
    /* ===== Add the item(s) to the cart ===== */
    try {
      // Add the main product to the cart
      const mainProductAdded = await this.addProductToCart(routes.cart_add_url, this.fetchConfigWithBody());
      
      const addTextOnSleeveInputs = Array.from(this.form.querySelectorAll('[name="properties[add_text_on_sleeve]"]'));
      const addTextOnSleeveSelectedInput = addTextOnSleeveInputs.find((input) => input.checked);

      const secondAddTextOnSleeveInputs = Array.from(this.form.querySelectorAll('[name="properties[second_add_text_on_sleeve]"]'));
      const secondAddTextOnSleeveSelectedInput = secondAddTextOnSleeveInputs.find((input) => input.checked);
      
      const addTextOnDesignInputs = Array.from(this.form.querySelectorAll('[name="properties[add_text_on_design]"]'));
      const addTextOnDesignSelectedInput = addTextOnDesignInputs.find((input) => input.checked);
      
      const addOneMoreDesignInputs = Array.from(this.form.querySelectorAll('[name="properties[add_one_more_design]"]'));
      const addOneMoreDesignSelectedInput = addOneMoreDesignInputs.find((input) => input.checked);
       
      const printOnBothSidesInputs = Array.from(this.form.querySelectorAll('[name="properties[print_on_both_sides]"]'));
      const printOnBothSidesSelectedInput = printOnBothSidesInputs.find((input) => input.checked);

      if (addTextOnSleeveSelectedInput && (addTextOnSleeveSelectedInput.getAttribute("product-type")?.toLowerCase().includes("hoodies") || addTextOnSleeveSelectedInput.getAttribute("product-type")?.toLowerCase().includes("sweatshirts"))) {
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(49183867863320, this.quantity));
      }

      if (secondAddTextOnSleeveSelectedInput && (secondAddTextOnSleeveSelectedInput.getAttribute("product-type")?.toLowerCase().includes("hoodies") || secondAddTextOnSleeveSelectedInput.getAttribute("product-type")?.toLowerCase().includes("sweatshirts"))) {
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(49763948298520, this.quantity));
      }
      
      if (addTextOnSleeveSelectedInput && addTextOnSleeveSelectedInput.getAttribute("product-type")?.toLowerCase().includes("t-shirts") || addOneMoreDesignSelectedInput && addOneMoreDesignSelectedInput.getAttribute("product-type")?.toLowerCase().includes("caps")) {
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(49196422234392, this.quantity));
      }

      if (secondAddTextOnSleeveSelectedInput && secondAddTextOnSleeveSelectedInput.getAttribute("product-type")?.toLowerCase().includes("t-shirts")) {
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(49764651467032, this.quantity));
      }

      // if (addTextOnSleeveSelectedInput && addTextOnSleeveSelectedInput.getAttribute("product-type")?.toLowerCase().includes("t-shirts")) {
      //   await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(49406041456920, this.quantity));
      // }

      if (addTextOnDesignSelectedInput && addTextOnDesignSelectedInput.value.includes("+") && printOnBothSidesSelectedInput && printOnBothSidesSelectedInput.value.includes("+")) {
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(49576708210968, this.quantity));
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(printOnBothSidesSelectedInput.value.includes("1.99") ? 49365684257048 : 49365685174552, this.quantity));
      }

      if (addTextOnDesignSelectedInput && addTextOnDesignSelectedInput.value.includes("+") && printOnBothSidesSelectedInput && !printOnBothSidesSelectedInput.value.includes("+")) {
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(49576708210968, this.quantity));
      }

      if (printOnBothSidesSelectedInput && printOnBothSidesSelectedInput.value.includes("+") && addTextOnDesignSelectedInput && !addTextOnDesignSelectedInput.value.includes("+")) {
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(printOnBothSidesSelectedInput.value.includes("1.99") ? 49365684257048 : 49365685174552, this.quantity));
      }
      
      if (mainProductAdded && this.giftWrapEnabled()) {
        // Add the gift wrap product to the cart
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(this.giftWrapProductId, this.quantity));
      }
      
      // Process the response
      this.processResponse(mainProductAdded);
    } catch (error) {
      console.error(`Error adding item(s) to cart: ${error.description || error.message}`);
    }
  }

  async addProductToCart(url, config) {
    /* ===== Add the product to the cart ===== */
    const response = await fetch(url, config);
    if (response.ok) {
      // Update cart drawer
      if (this.cartType === 'drawer') {
        const responseJson = await response.json();
        this.updateCartDrawer(responseJson);
      }
    } else {
      console.error(`Error adding item to cart: ${response.description || response.statusText}`);
    }
    return response;
  }

  additionalProductConfig(productId, quantity) {
    /* ===== Create the configuration object for the additional product(s) to be added to the cart ===== */
    const additionalItemPayload = { items: [{ id: productId, quantity: quantity }] };
    if (this.cartType === 'drawer') {
      additionalItemPayload['sections'] = 'cart-drawer';
    }
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(additionalItemPayload)
    };
  }

  updateCartDrawer(responseJson) {
    eventBus.emit('update:cart:drawer', responseJson);
  }

  async getCart() {
    /* ===== Fetch the cart information ===== */
    try {
      const response = await fetch(`${routes.cart_url}?view=compare`);
      return await response.json();
    } catch (error) {
      console.error(`Error fetching cart: ${error.description || error.message}`);
    }
  }

  updateCartCountIndicator() {
    /* ===== Update the cart count indicator ===== */
    if (!this.cartCountIndicator) return;
    this.getCart().then(cart => window.wetheme.updateCartCount(cart));
  }

  fetchConfigWithBody() {
    /* ===== Create the fetch configuration object with the form data as the body ===== */
    const config = this.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = this.addSectionsParam(new FormData(this.form));
    return config;
  }

  addSectionsParam(formData) {
    /* ===== Add the sections parameter to the form data for cart drawer rendering ===== */
    if (this.cartType === 'drawer') {
      formData.append('sections', 'cart-drawer');
    }
    return formData;
  }

  processResponse(response) {
    /* ===== Process the response from the server ===== */
    if (response.ok) {
      this.hideLoadingState();
    }

    // Handle the case where the product is out of stock
    if (response.status === 422) {
      window.eventBus.emit('render:cart:drawer');
      this.hideLoadingState();
      if (this.qtyErrorMessage) this.qtyErrorMessage.classList.remove('hidden');
    }

    // Emit the cart:added event
    eventBus.emit('cart:added', { sectionId: this.sectionId });
    // Re-enable the blank inputs
    this.enableBlankInputs();
  }

  openCartDrawer() {
    /* ===== Open the cart drawer ===== */
    eventBus.emit('open:cart:drawer', { scrollToTop: true });
  }

  showLoadingState() {
    /* ===== Show the loading state of the add to cart button ===== */
    this.toggleElements(this.addToCartText, false);
    this.toggleElements(this.loadingIcon, true, 'hidden');
    this.toggleAddButton(true);
  }

  hideLoadingState() {
    /* ===== Hide the loading state of the add to cart button ===== */
    this.toggleElements(this.loadingIcon, false, 'hidden');
    this.toggleCartActionDisplay();
  }

  toggleCartActionDisplay() {
    /* ===== Toggle the cart action display based on the selected action ===== */
    if (this.cartAction === 'show_added_message' && this.addedText) {
      // Show the added text message and update the cart count indicator
      this.addedText.style.display = 'block';
      setTimeout(() => {
        this.toggleAddToCartText(true);
        this.toggleAddButton(false); 
        this.updateCartCountIndicator();
      }, 2000);
    } else if (this.cartType === 'drawer' && this.cartAction === 'go_to_or_open_cart') {
      // Open the cart drawer 
      this.toggleAddToCartText(true);
      this.openCartDrawer();
      this.toggleAddButton(false);
      this.updateCartCountIndicator();
    } else {
      // Redirect to the cart page
      this.toggleAddToCartText(true);
      this.toggleAddButton(false);
      window.location = window.routes.cart_url;
    }
  }

  toggleAddToCartText(show) {
    /* ===== Toggle the add to cart text and the added text message ===== */
    // Show the added text message and hide the add to cart text
    if (this.addedText) this.addedText.style.display = show ? 'none' : 'block';
    // Show the add to cart text and hide the added text message
    if (this.addToCartText) this.addToCartText.style.display = show ? 'block' : 'none';
  }

  toggleElements(element, show, className) {
    /* ===== Toggle the display of the element based on the show value ===== */
    if (!element) return;
    if (className) {
      show ? element.classList.remove(className) : element.classList.add(className);
    } else {
      element.style.display = show ? 'block' : 'none';
    }
  }

  toggleAddButton(disable = true) {
    /* ===== Toggle the state of the add to cart button ===== */
    const addButton = this.querySelector('[name="add"]');
    if (!addButton) return;

    addButton.disabled = disable;
  }

  disconnectedCallback() {
    /* ===== Remove the event listeners when the element is removed from the DOM ===== */
    this.form.removeEventListener('submit', this.onSubmitBound);
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}

/******/ })()
;